const mapValues = require('lodash/mapValues');
const omitBy = require('lodash/omitBy');
const get = require('lodash/get');


export function ngrsEnabledAndRSLinkIsOnlyService(serviceinfo) {
    if (this.isNgrs() && serviceinfo && serviceinfo.length === 1) {
        return serviceinfo[0].type === 'AlmaResourceSharing';
    }
    return false;
}

export function isNgrs() {
    if ( window.appConfig['system-configuration'] && window.appConfig['system-configuration'].ngrs_enabled
    	&& passesNgrsImplementationModeCheck() && useRapidoDisplay()) {
        return true;
    }
    return false;
}

export function hasTitle(item: Object): boolean {
    const resourceType = getResourceType(item);
    const titleArr = get(item, 'pnx.display.title');
    let title = titleArr && titleArr.length > 0 ? titleArr[0] : undefined;
    switch (resourceType) {
        case 'book':
        case 'proceeding':
            const partOf = get(item, 'pnx.display.part_of');
            if (partOf && partOf[0]) {
                const partOfSplited = partOf[0].split(',');
                title = partOfSplited[0];
            }
            break;
        case 'article':
            const articleTitleArr = get(item, 'pnx.addata.atitle');
            const articleBTitleArr = get(item, 'pnx.addata.btitle');
            const articleTitle = articleTitleArr && articleTitleArr.length > 0 ? articleTitleArr : '';
            const articleBTitle = articleBTitleArr && articleBTitleArr.length > 0 ? articleBTitleArr : '';
            title = articleTitle + ' ' + articleBTitle;
            break;
        default:
            break;
    }

    return title && title.trim().length > 0;
}


export function filteredServices(serviceinfo){
    let result = serviceinfo;
    if(this.isNgrs()){
        result = serviceinfo.filter((currService)=>{
            return currService.type !== 'AlmaResourceSharing'
        });
    }else{
        result = serviceinfo;
    }
    return result;
}

export function getResourceType(item){
    let resourceType = get(item, 'pnx.addata.genre[0]');
    if(!resourceType || resourceType == 'unknown'){
        resourceType = get(item, 'pnx.display.type[0]','b').toLowerCase();
		if(!resourceType || resourceType == 'unknown'){
			resourceType='unknown';
		}
    }
    return resourceType.toLowerCase();
}

export function getGenreType(item){
    let resourceType = get(item, 'pnx.addata.genre[0]');
    if(!resourceType){
	    resourceType = 'unknown';
    }
    return resourceType.toLowerCase();
}

export function passesNgrsImplementationModeCheck() {
    if (window.appConfig['system-configuration'] && window.appConfig['system-configuration'].ngrs_implementation_mode) {
        if(isRapidoFlagOn()) {
        	return true;
        } else {
        	return false;
        }
    }
    return true;
}

export function useRapidoDisplay() {
    if (window.appConfig['system-configuration'] && window.appConfig['system-configuration'].use_rapido_functionality) {
        return true;
    }
    return false;
}

export function isRapidoFlagOn() {
    try {
		let isRapido = window.sessionStorage.getItem("isRapido");
    	return isRapido === 'true';
    } catch (err) {
    	//safari incognito mode will throw error here
    }
    return false;
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/ngrsUtil.ts